module.exports = __webpack_public_path__ + "static/img/banner_img3.c978129.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_img3.png
// module id = 8dFy
// module chunks = 4